module.exports = __webpack_public_path__ + "9a895c1fe0cfb5c4928e38153f9e1f6b.pdf";